import * as types from './mutation-types'

export default {
  [types.SET_FOLLOW_UP_RULE] (state, payload) {
    if (payload === null) {
      payload = {}
    }
    state.followUpRule = payload
  },
  [types.SET_FOLLOW_UP_RULES] (state, payload) {
    state.followUpRules = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  }
}
